export default String.raw`
{% assign wishlist = customer-profile.WishListsProductsPagination -%}
    <div class="wishlist-global-container-js parent-container-js" data-url="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=wishlist-details&{{ customer-profile.WishListsQueryGET }}={{wishlist.WishListId}}">
        {% assign whatPrice = translations.Brutto | Downcase -%}
        {% if customer.Cart.SubtotalPrices -%}
            {% assign whatPrice = translations.Netto | Downcase -%}
        {% endif -%}
    <div class="page-padding">
        <div class="wishlist-container">
            <div class="wishlist-list wishlist-container-js">
                <div class="wishlist-list__header submenu-header">
                    <div class="navigation-header">
                        <a class="pure-button" aria-label="homePage"{% if config.B2B -%} href="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=wishlists" {% else -%} href="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=wishlist" {% endif -%}>
                            <svg width="24" height="24">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
                            </svg>
                        </a>
                        <span class="title">{{ wishlist.Name }}</span>
                    </div>
                    <div class="options submenu">
                        <button class="pure-button open-dropdown-js">
                            {{ translations.More }}
                            <svg height="16" width="16" class="icon rotate-down dropdown-arrow">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                            </svg>
                        </button> 
                        <div class="dropdown dropdown-js hidden-js">
                            {% if wishlist.TotalItems > 0 -%}
                                <button aria-label="add-all-to-inquiry-button" class="pure-button add-all-to-inquiry-from-wishlist-js">
                                    <span>
                                        {{ translations.AddToInquiry }}
                                    </span>
                                </button>
                            {% endif -%}
                            <button class="pure-button change-wishlist-name-js" 
                                data-wishlist-id="{{ wishlist.WishListId }}" 
                                data-wishlist-name="{{ wishlist.Name }}">
                                {{ translations.ChangeName }}
                            </button>
                            <button class="pure-button prepare-delete-wishlist-popup-js delete-from-wishlist-details-js" data-wishlist-name="{{ wishlist.Name }}">
                                {{ translations.DeleteWishList }}
                            </button>
                        </div>
                        {% if wishlist.TotalItems > 0 -%}
                            <button aria-label="add-all-to-cart-button" class="primary-action-button add-all-to-cart-from-wishlist-js">
                                <i class="{{settings.cartIconStyle}}"></i>
                                <span>
                                    {{ translations.AddToCart }}
                                </span>
                            </button>
                        {% endif -%}
                    </div>
                </div>

                <div class="order-details not-expandable">
                    <div class="order-details__row">
                        <div class="order-details-item">
                            <div class="title">{{ translations.NumberOfProducts }}</div>
                            <span>{{ wishlist.TotalItems }}</span>
                        </div>
                        <div class="order-details-item">
                            <div class="title">{{ translations.ModificationDate }}</div>
                            <span>{{ wishlist.ModificationDate | Date:'dd.MM.yyyy HH:mm' }}</span>
                        </div>
                        <div class="order-details-item">
                        <label for="notifyDate">{{ translations.ReminderDate}}</label>
                            {% assign day = '1.00:00:00' | ToTimeSpan -%}
                            {% assign minDate = config.Now | Plus:day | Date:'yyyy-MM-dd' -%}
                            {% assign savedDate = wishlist.NotificationDate | Date:'yyyy-MM-dd' -%}
                            <input id="notifyDate" class="form__input-value update-reminder-date-js" type="date" name="notifyDate" value="{% if savedDate >= minDate -%}{{savedDate}}{% endif -%}" min="{{minDate}}" max="2200-12-31" style="width: 150px;">
                        </div>
                    </div>
                </div>
                
                <div class="wishlist-table-js">
                    {% include 'partials/wishlist/wishlist-table.html' -%}
                </div>
            </div>

            <div class="message-popup-background delete-wishlist-popup-js hidden-js container-to-hide-js">
                <div class="popup-container">
                    <div class="data-form">
                        <div class="data-form__header">
                            {{ translations.DeleteWishList }}
                        </div>
                            <input type="hidden" name="wishlistId" value="{{ wishlist.WishListId }}"  >
                            <div>{{ translations.DeleteWishListInfo }} <strong>{{ wishlist.Name }}</strong> ?</div>
                        <div class="buttons-container">
                            <button aria-label="hide-container" class="pure-button hide-container-js">
                                {{ translations.Cancel }}
                            </button>
                            <button aria-label="delete-wishlist" class="primary-action-button delete-wishlist-js" data-url="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=wishlist">
                                {{ translations.YesDelete }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="message-popup-background change-wishlist-popup-js hidden-js container-to-hide-js">
                <div class="popup-container">
                    <div class="data-form">
                        <div class="data-form__header">
                            {{ translations.ChangeName }}
                            <button aria-label="hide-container" class="close-button hide-container-js">
                                <svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
                            </button>
                        </div>
                        <input type="hidden" name="wishlistId" >
                        <div class="form__input-wrapper">
                            <label for="newWishlistName" class="form__input-info input-info-js on-label">{{ translations.Com_NAME }}</label>
                            <input aria-label="{{ translations.Com_NAME }}" class="form__input-value input-value-js" id="newWishlistName" type="text" placeholder="{{ translations.EnterName }}" maxlength="500" name="wishlistName" >
                        </div>
                        <div class="buttons-container">
                            <button aria-label="hide-container" class="pure-button hide-container-js">
                                {{ translations.Cancel }}
                            </button>
                            <button aria-label="save-wishlist-name" class="primary-action-button save-wishlist-popup-js">
                                {{ translations.saveBtn }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="during-ajax-modal-js during-ajax-modal hidden-js">
                <div class="loader big"></div>
            </div>
        </div>
    </div>
</div>
`